import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { EDEN_API_PATH } from '@/utils/constants';
import { Ratio } from '@/models/zoneplacement';
import { http } from '@/utils/http';

export interface LibraryCreative {
  id: number;
  name: string;
  campaign_group_name: string;
  ad_group_name: string;
  duration_ms: number;
  orientation: 'LANDSCAPE' | 'PORTRAIT';
  assets: {
    id: number;
    type: 'video' | 'thumbnail';
    url: string;
  }[];
}

interface Response {
  creatives: LibraryCreative[];
}

async function getLibraryCreatives(ratio: Ratio | undefined, search: string) {
  const { data } = await http.get<Response>('/dynamic-creative/list', {
    baseURL: EDEN_API_PATH,
    params: {
      orientation: ratio === '9:16' ? 'PORTRAIT' : 'LANDSCAPE',
      search: search || undefined,
    },
  });

  return data.creatives;
}

export function useLibraryCreatives(ratio: Ratio | undefined, search: string) {
  return useQuery({
    enabled: Boolean(ratio),
    queryKey: ['promotions', 'library-creatives', { ratio, search }],
    queryFn: () => getLibraryCreatives(ratio, search),
    placeholderData: keepPreviousData,
  });
}
